import { CustomPopoverProps, IconName } from '@aibees/shared/components';
import { ChipProps } from '@mui/material';
import { ReactNode } from 'react';

export interface SeeAllPopupItems {
  text: string;
  key: string;
  element: ReactNode;
}
export interface SeeAllPopupProps<T = any> extends CustomPopoverProps {
  className?: string;
  placeholder?: string;
  buttonTitle?: string;
  items: SeeAllPopupItems[];
  header?: ReactNode;
  title?: ReactNode;
}

export enum TagAction {
  INCLUDE_IN_EXISTING_SEARCH = 'Include in Existing Search',
  EXCLUDE_IN_EXISTING_SEARCH = 'Exclude in Existing Search',
  INCLUDE_IN_NEW_SEARCH = 'Include in New Search',
  EXCLUDE_IN_NEW_SEARCH = 'Exclude in New Search',
}

export enum SeaAllFilterField {
  industry = 'industry',
  technologies = 'technologies',
  products_and_services = 'products_and_services',
  naics = 'naics',
}

export type SeaAllPopoverAction = {
  placeholder?: string;
  actions?: TagAction[];
  field?: SeaAllFilterField;
  includeSearch?: string;
  excludeSearch?: string;
};

export interface TagItem {
  label: string;
  props?: ChipProps;
  startIcon?: IconName;
  customLabel?: ReactNode;
}
